<template>
  <section
    :class="{ '-is-centered': centeredDescription }"
    class="article-head"
  >
    <ui-wrapper narrow>
      <ul v-if="date" class="article-head-details">
        <li v-html="date" />
        <li v-if="readingTime">
          <ui-icon name="navigation-timer" />
          <span v-html="readingTime" />
        </li>
      </ul>
      <component :is="titleTag" class="article-head-title">
        <span v-html="title"></span>
      </component>
      <div v-if="description" class="article-head-description edito" v-html="description" />
    </ui-wrapper>

    <ui-summary v-if="summaryData" v-bind="summaryData" />
  </section>
</template>

<script>
import { defineAsyncComponent } from 'vue'
const UiIcon = defineAsyncComponent(() => import('Foundations/ui-icon'))
const UiSummary = defineAsyncComponent(() => import('Molecules/ui-summary'))
import UiWrapper from 'Foundations/ui-wrapper'

export default {
  name: 'ArticleHead',
  components: { UiSummary, UiIcon, UiWrapper },
  props: {
    readingTime: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    titleTag: {
      type: String,
      default: 'h1'
    },
    description: {
      type: String,
      default: null
    },
    centeredDescription: {
      type: Boolean,
      default: false
    },
    summaryData: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss">
.article-head {
  @include spacing-top-s;

  .article-head-details {
    @include body-text-xs;
    color: $color-bold-gray;
    display: flex;
    justify-content: center;
    padding: 0;
    margin: 0;
    list-style-type: none;

    li {
      display: flex;
      align-items: center;
    }

    li:not(:last-child) {
      margin-right: april-rem($spacing-l);
    }

    .ui-icon {
      height: april-rem(12);
      width: april-rem(12);
      margin-right: april-rem($spacing-xs);
      fill: $color-bold-gray;
    }
  }

  .article-head-title {
    margin: april-rem($spacing-m) 0 0;
    text-align: center;
    @include title-1;
  }

  .ui-summary {
    margin-top: april-rem($spacing-2xl);
  }

  .article-head-description {
    @include body-text-m;
    margin-top: april-rem($spacing-2xl);
  }

  &.-is-centered .article-head-description {
    text-align: center;
  }

  @media #{$mq-medium} {
    .article-head-title {
      margin: april-rem($spacing-l) 0 0;
    }

    .article-head-description {
      @include body-text-l;
      margin-top: april-rem($spacing-3xl);
    }
  }
}
</style>
